import { NavLink } from "react-router-dom";
import { memo } from "react";
import { TabMenuProps } from "./types";
import { classNames, transformRoute, useTranslate } from "helpers";
import { Routes as FleetTireRoutes } from "ui/modules/fleet/tires/navigation";
import { ReactSVG } from "react-svg";

const TabMenu: React.FC<TabMenuProps> = (props) => {
  const { tireSetId } = props;
  const { t } = useTranslate();

  return (
    <>
      <div className="flex border-b border-slate-200">
        <NavLink
          to={transformRoute(FleetTireRoutes.FleetTireSetDetailPageRouter, {
            id: tireSetId,
          })}
        >
          {({ isActive }) => (
            <div
              className={classNames(
                "group flex items-center gap-2 font-semibold pl-2 pr-4 py-2 ml-3 hover:text-sky-600",
                isActive
                  ? "text-sky-600 border-b-2 border-b-sky-600"
                  : "text-gray-600"
              )}
            >
              <ReactSVG
                src="/media/icons/info.svg"
                className={classNames(
                  "w-5 h-5 group-hover:stroke-sky-600",
                  isActive ? "stroke-sky-600" : "stroke-slate-500"
                )}
              />
              {t("admin.fleet.tires.set.tab.details")}
            </div>
          )}
        </NavLink>

        <NavLink
          to={transformRoute(FleetTireRoutes.FleetTireSetDocumentSearchPageRouter, {
            id: tireSetId,
          })}
        >
          {({ isActive }) => (
            <div
              className={classNames(
                "group flex items-center gap-2 font-semibold pl-2 pr-4 py-2 hover:text-sky-600",
                isActive
                  ? "text-sky-600 border-b-2 border-b-sky-600"
                  : "text-gray-600"
              )}
            >
              <ReactSVG
                src="/media/icons/document.svg"
                className={classNames(
                  "w-5 h-5 group-hover:stroke-sky-600",
                  isActive ? "stroke-sky-600" : "stroke-slate-500"
                )}
              />
              Dokumenti
            </div>
          )}
        </NavLink>
      </div>
    </>
  );
};

export default memo(TabMenu);
